import { ColumnDetails } from '../../../grid/types/common';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { ButtonHeights, ButtonTypes } from '../../../ui/gzButton/types';
import { htmlDecode, htmlEncode } from '../../../utils/escape.utils';
import {
  handleClickOnEndpoint,
  handleClickOnIncidentNumber,
} from '../../../../../../libs/shared/common/src/lib/eventHandlers';
import { Column, ColumnKeys } from '../types';
import { gridCustomHtmlRenderer } from '../../../grid/utils/renderers';
import { GzTooltipWebComponent } from '../../../ui/gzTooltip';
import { translateFn } from '../../../utils/translator.helper';
import { html } from 'lit';

export function endpointRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  const button = document.createElement('gz-button') as GzButtonWebComponent;
  button.type = ButtonTypes.QUIET;
  button.buttonHeight = ButtonHeights.SMALL;
  button.lowercase = true;
  button.innerHTML = cellValue;
  button.setAttribute('data-endpoint-id', rowData.item.endpointId);
  button.addEventListener('click', handleClickOnEndpoint.bind(this));
  button.disabled = false;

  const parsedEvent = JSON.parse(htmlDecode(rowData.item['rawEvent']));
  if (parsedEvent?.is_gz_demo) {
    button.disabled = true;
    const tooltip = new GzTooltipWebComponent();
    tooltip.tooltipText = translateFn('Not available in demo mode.');
    tooltip.appendChild(button);
    return tooltip;
  }

  return button;
}

export function alertIncidentNumberRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  let cellValue = rowData.item[columnDetails.key];

  if (!cellValue) {
    return gridCustomHtmlRenderer(
      `
        <span class="cell-label">-</span>`
    );
  }

  const parsedEvent = JSON.parse(htmlDecode(rowData.item['rawEvent']));

  // render label
  cellValue = parsedEvent?.is_gz_demo ? '#DEMO' : `#${cellValue}`;
  let isEdr = true;
  if (parsedEvent?.['other']?.['event_type'] === 'xalert') {
    cellValue += ' (XDR)';
    isEdr = false;
  }

  // set incident details needed for navigation
  let incidentDetails = '{}';
  if (parsedEvent?.['incidentsDetails']?.[0]) {
    incidentDetails = JSON.stringify(parsedEvent.incidentsDetails[0]);
  }

  // build link
  const button = document.createElement('gz-button') as GzButtonWebComponent;
  button.type = ButtonTypes.QUIET;
  button.buttonHeight = ButtonHeights.SMALL;
  button.lowercase = true;
  button.innerHTML = cellValue;
  button.setAttribute('data-incident-id', parsedEvent['alert']['incident_id']);
  button.setAttribute('data-incident-is-edr', '' + isEdr);
  button.setAttribute('data-incident-details', incidentDetails);
  button.addEventListener('click', handleClickOnIncidentNumber.bind(this));
  return button;
}

export function countDefaultValueRenderer(rowData) {
  const parsedEvent = JSON.parse(htmlDecode(rowData.item['rawEvent']));
  let count = 1;

  if (parsedEvent?.['other']?.['count']) {
    count = parsedEvent?.['other']?.['count'];
  }
  return gridCustomHtmlRenderer(
    `
        <span class="cell-label">${count}</span>`
  );
}

export function sanitizePathValueRenderer(rowData, columnDetails: ColumnDetails<any, any>) {
  const cellValue = escapeBackslash(rowData.item[columnDetails.key]);

  if (!Array.isArray(cellValue)) {
    return gridCustomHtmlRenderer(`<span class="cell-label">${htmlEncode(cellValue)}</span>`);
  }

  const firstValue = htmlEncode(cellValue[0]);
  const valueCounter =
    cellValue.length > 1 ? html`<span class="multiple-value__counter">+${cellValue.length - 1}</span>` : '';
  return html` <gz-grid-cell-default-renderer
    .label="${html`${firstValue}${valueCounter}`}"
  ></gz-grid-cell-default-renderer>`;
}

export function escapeBackslash(value) {
  if (
    (value && typeof value === 'string' && (value.indexOf(' ') >= 0 || value.indexOf('/') >= 0)) ||
    String.raw`${value}`.indexOf('\\') >= 0
  ) {
    value = String.raw`${value}`.replace(/\\/g, '\\\\');
    value = value.replace(/"/g, '\\"');
  }
  return value;
}
